<template>
  <!-- A standalone text field: sign-in forms, the playground, the feedback
       note. (A field with an icon or a button inside it is InputGroup.)
       16px on phones so iOS doesn't zoom in on focus; 14px from `sm`. `sm` is
       the compact height for a field inside a toolbar-like row.
       Attributes (id, type, placeholder, listeners…) land on the <input>. -->
  <input
    v-model="model"
    class="block w-full rounded-md border-0 bg-gray-900 px-3 text-base text-white shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset read-only:text-gray-300 sm:text-sm sm:leading-6"
    :class="[
      size === 'sm' ? 'py-1' : 'py-2',
      invalid ? 'ring-red-700 focus:ring-red-700' : 'ring-gray-700 focus:ring-indigo-500',
    ]"
    :aria-invalid="invalid || undefined"
  />
</template>

<script setup>
const model = defineModel({ type: [String, Number], default: '' })

defineProps({
  invalid: { type: Boolean, default: false },
  size: { type: String, default: 'md' },
})
</script>
